// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type { BaseResponseListCozeWorkspace } from '../../../types';

/**
 * 查询coze空间列表
 *
 * @export
 * @tags Coze智能体
 * @link [GET] /aiAgentConfigs/coze/workspaces
 */
export function getAiAgentConfigsCozeWorkspaces(): Promise<BaseResponseListCozeWorkspace>;
export function getAiAgentConfigsCozeWorkspaces(
    options: ApiOptions<never, never>
): Promise<BaseResponseListCozeWorkspace>;
export function getAiAgentConfigsCozeWorkspaces(
    options?: ApiOptions<never, never>
): Promise<BaseResponseListCozeWorkspace> {
    return request<never, never, never>('/aiAgentConfigs/coze/workspaces', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getAiAgentConfigsCozeWorkspaces',
    });
}

export const meta = [
    { tags: ['Coze智能体'], path: '/aiAgentConfigs/coze/workspaces', method: 'get' },
];
